import { render, staticRenderFns } from "./ProjectConnectionDetails.vue?vue&type=template&id=9af9c308&scoped=true&"
import script from "./ProjectConnectionDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectConnectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConnectionDetails.vue?vue&type=style&index=0&id=9af9c308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af9c308",
  null
  
)

export default component.exports